import * as React from "react";

interface Props {
  fill?: string;
}

export const EditIcon = ({ fill = "#2D5BFF" }: Props) => (
  <svg width={14} height={14} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.953.984c-.27 0-.531.052-.781.157-.25.104-.474.255-.672.453L1.594 9.5l-.578 2.906-.157.735.735-.157 2.906-.578L12.406 4.5c.271-.27.448-.578.531-.922a1.984 1.984 0 0 0 0-1.047 1.933 1.933 0 0 0-.53-.937 2.068 2.068 0 0 0-.673-.453 2.012 2.012 0 0 0-.78-.157Zm0 .954c.26 0 .51.12.75.359.24.24.36.49.36.75s-.12.51-.36.75l-.36.344L9.86 2.656l.344-.36c.24-.239.49-.358.75-.358ZM9.156 3.359l1.485 1.485-6.047 6.047a3.302 3.302 0 0 0-1.485-1.485L9.156 3.36ZM2.47 10.22c.302.125.562.302.781.531.23.219.406.48.531.781l-1.64.328.328-1.64Z"
      fill={fill}
    />
  </svg>
);
